import styled, { css } from 'styled-components';

function backgroundStyle({
  $isSolid,
  $type,
  theme
}) {
  var _theme$message$$type;
  const background = (_theme$message$$type = theme.message[$type]) === null || _theme$message$$type === void 0 ? void 0 : _theme$message$$type[$isSolid ? 'solidBg' : 'bg'];
  return background ? css(["background:", ";"], background) : '';
}
function borderStyle({
  $isSolid,
  $type,
  theme
}) {
  var _theme$message$$type2;
  const borderColor = $isSolid ? null : (_theme$message$$type2 = theme.message[$type]) === null || _theme$message$$type2 === void 0 ? void 0 : _theme$message$$type2.borderColor;
  return borderColor ? css(["border:", " solid ", ";"], theme.message.borderWidth, borderColor) : '';
}
function borderRadiusStyle({
  $isSolid,
  theme
}) {
  const borderRadius = $isSolid ? null : theme.message.borderRadius;
  return borderRadius ? css(["border-radius:", ";"], borderRadius) : '';
}
function contentAlignStyle({
  $isSolid
}) {
  return $isSolid ? css(["text-align:center;align-items:center;"]) : '';
}
const StyledMessage = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30074613__sc-1qy01t3-0"
})(["position:relative;display:flex;margin-right:", ";overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;padding:", ";", " ", " ", " ", ""], ({
  inline,
  theme
}) => inline ? theme.spacing.mini : '0', ({
  $isSolid,
  theme
}) => $isSolid ? theme.spacing.small : theme.spacing.base, borderStyle, borderRadiusStyle, backgroundStyle, contentAlignStyle);
StyledMessage.displayName = 'StyledMessage';

export { StyledMessage as S };
//# sourceMappingURL=Message-CcOf6XiM.js.map
